module.exports = __webpack_public_path__ + "img/tutorial-f03-02.1378b2cf.png";